var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar round",attrs:{"src":_vm.avatarImage,"id":"movingHead","alt":"Tumi avatar","width":"130"}})}
var staticRenderFns = []

export { render, staticRenderFns }